import { type FormInput, FormInputType } from '../support.type';
import { FormFieldImageUploader } from './FormFieldImageUploader';
import { FormFieldRating } from './FormFieldRating';
import { FormFieldInput } from './FormFieldInput';
import { type FormField } from './FormField';

export function formFieldFactory<T>(_formData: FormInput): FormField<T> {
    switch (_formData.formInputType) {
        case FormInputType.File:
            return new FormFieldImageUploader(_formData) as FormField<T>;
        case FormInputType.Rating:
            return new FormFieldRating(_formData) as FormField<T>;
        case FormInputType.Text:
        case FormInputType.MultilineText:
            return new FormFieldInput(_formData) as FormField<T>;
        default:
            throw new Error('Invalid FormInputType');
    }
}
